








import { Component, Vue } from "vue-property-decorator";

// @components
import DataTable from "@/components/Settings/ManageVessels/DataTable.vue";

//  modules

@Component({
  components: {
    DataTable,
  },
})
export default class ManageVessels extends Vue {
  // @Data
  get themeClass(): string {
    return this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
  }
}
